import { Box } from "@mui/material";
import { PropsWithChildren, memo } from "react";
import { CompanyInfoBlock } from "./CompanyInfoBlock";
import { ActivitiesBlock } from "./ActivitiesBlock";
import { MaterialBlock } from "./MaterialBlock";
import { theme } from "$utils/theme/bataillog";
import { ICompany } from "$services/Entreprises.service";
import { usePopin } from "$components/Popin/usePopin";
import { useStyles } from "../styles";

import EntrepriseForm from "../../EntrepriseForm";
import useCompanyForm from "$hooks/useCompanyForm";
import { CompanyType } from "$types";

export const ResumeCompany = memo(function ResumeCompany({
  company,
  cantEditCurrentTab,
  selectedTab,
  isLoading,
  contributors,
  clients,
  carrier,
  logiWarehouse,
  clientsWithCatalogue,
}: {
  company: ICompany;
  cantEditCurrentTab: boolean;
  selectedTab: string; // patch for the panel
  isLoading: boolean;
  contributors: any;
  clients: any;
  carrier: any;
  clientsWithCatalogue: any;
  logiWarehouse: any;
}) {
  const classes = useStyles();
  const { Popin, openPopin, togglePopin, PopinProps } = usePopin();

  // @todo amir: why it's useless ? we still need it to make the component reusable !
  // TODO will remove this with the form update, it's useless
  const { handleSubmit, error, submitting } = useCompanyForm(
    undefined,
    togglePopin
  );

  function WrapperBox({ children }: PropsWithChildren) {
    return (
      <Box
        style={{
          display: "flex",
          alignItems: "stretch",
          gap: theme.spacing(2),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <WrapperBox>
      <CompanyInfoBlock
        company={company}
        isDisabled={cantEditCurrentTab}
        tab={selectedTab}
        openPopin={openPopin}
        contributors={contributors}
        clients={clients}
        carrier={carrier}
        logiWarehouse={logiWarehouse}
        isLoading={isLoading}
      />

      {company?.activities?.length > 0 && (
        <Box className={classes.topRightBlock}>
          <ActivitiesBlock
            activities={company?.activities}
            isDisabled={cantEditCurrentTab}
            openPopin={openPopin}
          />
        </Box>
      )}

      {company?.companyTypes?.some((t) =>
        [CompanyType.CLIENT, CompanyType.CONTRIBUTOR].includes(t)
      ) &&
        selectedTab !== CompanyType.SUPPLIER && (
          <Box className={classes.topRightBlock}>
            <MaterialBlock
              company={company}
              tab={selectedTab}
              isDisabled={cantEditCurrentTab}
              clientsWithCatalogue={clientsWithCatalogue}
            />
          </Box>
        )}

      <Popin {...PopinProps}>
        <EntrepriseForm
          onSubmit={handleSubmit}
          onReset={togglePopin}
          companyError={error}
          isSubmitting={submitting}
          defaultValues={{
            ...company,
            sector: company?.sector as any,
          }}
        />
      </Popin>
    </WrapperBox>
  );
});
